module.exports = __webpack_public_path__ + "img/check.0b6054fb.svg";